import { Environment } from './environment.interface';
export { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  brands: {
    enelx: {
      baseUrl: '/',
    },
  },
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
  },
  dataprovider_id: {
    ENEL_IOT_FLEXIBILITY : '72e87824-29d6-4c55-8be6-6769f4deda8c',
  },
};
